import { GetListParams, SortInterface } from '@core/interfaces/get-list.interface';
import { NgbDateRange } from '@core/interfaces/date-filter.interface';
import { OffsetPagination } from '@core/interfaces/pagination-params.interface';
import { RequestTimeWindowFilter } from '@core/interfaces/requests-time-windows.interface';

export class GetListRequestTimeWindow {
  static readonly type = '[RequestTimeWindow] Get List';

  constructor(public params: GetListParams<RequestTimeWindowFilter>) {}
}

export class SetRequestTimeWindowFilter {
  static readonly type = '[SetRequestTimeWindowFilter] Set Request Time Window Filter';

  constructor(public filter: RequestTimeWindowFilter) {}
}

export class SetRequestTimeWindowDateFilter {
  static readonly type = '[SetRequestTimeWindowDateFilter] Set Request Time Window Date Filter';

  constructor(public dateFilter: NgbDateRange) {}
}

export class SetRequestTimeWindowPaginationParams {
  static readonly type = '[SetRequestTimeWindowPaginationParams] Set Request Time Window Pagination Params';

  constructor(public paginationParams: OffsetPagination) {}
}

export class SetRequestTimeWindowSortParams {
  static readonly type = '[SetRequestTimeWindowSortParams] Set Request Time Window Sort Params';

  constructor(public sortParams: SortInterface) {}
}

export class GetEstimationTimeSlotsDetails {
  static readonly type = '[RequestTimeWindow] Get Estimation Time Slots Details';

  constructor(public id: number) {}
}
